export const system = {
    settings: {
        title: 'Settings',
        general: 'General',
        websiteSettings: 'Website Settings',
        siteName: 'Site Name',
        logo: 'Logo',
        domainSettings: 'Domain Settings',
        userManagement: 'User Management',
        roleManagement: 'Role Management',
        trackingPixels: 'Tracking Pixels',
        customerService: 'Customer Service',
        brands: 'Brands',
        saveSettings: 'Save Settings',
        settingsSaved: 'Settings saved successfully!',
    },
    login: {
        title: 'Login to Dashboard',
        email: 'Email',
        password: 'Password',
        loginButton: 'Login',
        loggingIn: 'Logging in...',
        invalidCredentials: 'Invalid email or password',
        forgotPassword: 'Forgot Password?',
    },
    toast: {
        success: 'Success!',
        error: 'An error occurred',
        warning: 'Warning',
        info: 'Information',
    },
};
